var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDolarSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.125V5.75",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.25V25.875",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 10.125C20.125 9.55047 20.0118 8.98156 19.792 8.45076C19.5721 7.91996 19.2498 7.43766 18.8436 7.03141C18.4373 6.62515 17.955 6.30289 17.4242 6.08303C16.8934 5.86316 16.3245 5.75 15.75 5.75H11.8125C10.6522 5.75 9.53938 6.21094 8.71891 7.03141C7.89844 7.85188 7.4375 8.96468 7.4375 10.125C7.4375 11.2853 7.89844 12.3981 8.71891 13.2186C9.53938 14.0391 10.6522 14.5 11.8125 14.5H16.625C17.7853 14.5 18.8981 14.9609 19.7186 15.7814C20.5391 16.6019 21 17.7147 21 18.875C21 20.0353 20.5391 21.1481 19.7186 21.9686C18.8981 22.7891 17.7853 23.25 16.625 23.25H11.375C10.2147 23.25 9.10188 22.7891 8.28141 21.9686C7.46094 21.1481 7 20.0353 7 18.875",
    stroke: "#4BBA36",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolarSymbol);
export default __webpack_public_path__ + "static/media/dolar-symbol.70a35c03f7c4c12efb133a9f9a9bec81.svg";
export { ForwardRef as ReactComponent };